var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-layout"},[(_vm.$store.getters.isMobile)?_c('mobile-layout',[_vm._t("default")],2):_c('desktop-layout',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }